import { CircularProgress } from '@mui/material';
import React from 'react';

interface TableCell {
	children: React.ReactNode;
	isLoading?: boolean;
}

const TableCellWithLoading = ({ children, isLoading }: TableCell) => {
	const Element = isLoading ? (
		<CircularProgress data-testid="table-cell-spinner" size={18} />
	) : (
		children
	);
	return <>{Element}</>;
};

export default TableCellWithLoading;
